import { ResourceLevelingSettingBase } from './base/resource-leveling-setting-base';

export class ResourceLevelingSetting extends ResourceLevelingSettingBase { }